export default {
	title: '故障案例',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	noData: {
		title: '暂无故障案例',
		description: '当前没有找到相关的故障案例数据'
	},
	reportCard: {
		coverAlt: '故障案例封面',
		author: '编制人',
		reviewer: '校核人',
		approver: '审核人',
		updateTime: '更新时间'
	},
	status: {
		completed: '完成',
		editing: '编辑中'
	},
	actions: {
		generateReport: '生成报告',
		download: '下载',
		delete: '删除',
		edit: '修改',
		batchDelete: '批量删除'
	},
	messages: {
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		fileUploadSuccess: '文件上传成功',
		fileUploadError: '文件上传失败',
		fileTypeError: '只能上传 PDF、Word 文档格式!',
		fileSizeError: '文件大小不能超过 10MB!',
		generateReportSuccess: '生成报告成功'
	},
	form: {
		orgId: '机构',
		reportName: '报告名称',
		inspectDeviceReportId: '关联诊断报告',
		author: '编制人',
		reviewer: '校核人',
		approver: '审核人',
		analysis: '异常分析',
		advice: '处理建议',
		adviceAttachment: '处理附件',
		follow: '后续跟进',
		followAttachment: '跟进附件',
		warnInfo: '告警信息',
		sensorDiagram: '测点示意图',
		installConfig: '安装配置',
		attachment: '附件上传',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		add: '新增',
		update: '修改',
		cancel: '取消',
		confirm: '确定',
		startDate: '开始日期',
		endDate: '结束日期',
		fileUpload: '点击上传'
	},
	table: {
		reportName: '报告名称',
		fileName: '故障案例',
		inspectDeviceReportName: '关联诊断报告',
		author: '编制人',
		analysis: '异常分析',
		advice: '处理建议',
		createTime: '创建时间'
	},
	warnItem: {
		warnItem: '告警项',
		faultLocation: '故障部位',
		faultType: '故障类型',
		selectFaultType: '请选择故障类型',
		warnLevel: '告警等级',
		selectWarnLevel: '请选择告警等级',
		warnCount: '告警次数',
		diagnosisAnalysis: '诊断分析',
		enterDiagnosisAnalysis: '请输入诊断分析',
		relatedAtlas: '相关图谱',
		addAtlas: '添加图谱',
		diagnosisConclusion: '诊断结论',
		enterDiagnosisConclusion: '请输入诊断结论',
		maintenanceSuggestion: '维护建议',
		enterMaintenanceSuggestion: '请输入维护建议',
		warnStartTime: '告警开始时间',
		warnEndTime: '告警结束时间',
		selectDateAndTime: '选择日期时间'
	},
	vibrationData: {
		deviceName: '设备名称',
		sensorLoc: '测点位置',
		axial: '安装方向',
		sensorType: '传感器类型',
		enterDeviceName: '请输入设备名称',
		enterSensorLoc: '请输入测点位置',
		enterAxial: '请输入安装方向',
		enterSensorType: '请输入传感器类型',
		addVibrationData: '添加测点数据'
	},
	placeholder: {
		selectOrg: '请选择机构',
		enterReportName: '请输入报告名称',
		selectInspectReport: '请选择关联诊断报告',
		enterAuthor: '请输入编制人',
		enterReviewer: '请输入校核人',
		enterApprover: '请输入审核人',
		enterAnalysis: '请输入异常分析',
		enterAdvice: '请输入处理建议',
		enterFollow: '请输入后续跟进',
		fileUpload: '文件上传'
	}
}
